export class CreateAggregationServingTokenResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "hint",
            "baseName": "hint",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "activeAt",
            "baseName": "activeAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateAggregationServingTokenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
